import { render, staticRenderFns } from "./TheMapSound.vue?vue&type=template&id=0ff71a7b&scoped=true&"
import script from "./TheMapSound.vue?vue&type=script&lang=js&"
export * from "./TheMapSound.vue?vue&type=script&lang=js&"
import style0 from "./TheMapSound.vue?vue&type=style&index=0&id=0ff71a7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff71a7b",
  null
  
)

export default component.exports